import { PaymentMethod } from '../../../../core/reducers/financialCalculators';
import buildPaymentTab from './buildPaymentTab';
import getFallbackPaymentTab from './getFallbackPaymentTab';
import parseTemplateCtaLink from './parseTemplateCtaLink';
const paymentMethodTabTypeRecord = {
    [PaymentMethod.cash]: 'rebate',
    [PaymentMethod.finance]: 'finance',
    [PaymentMethod.lease]: 'lease',
};
function convertTrimsDataToCardProps({ config, trimsWithPaymentAndOffers, primaryCta, secondaryCta, showSellingPrice, hasLoyaltyOffer = false, onPaymentMethodChange, }) {
    const cards = trimsWithPaymentAndOffers.map(({ modelName, modelYear, trimName, modelLogo, modelKey, trimKey, transmissionId, transmissionKey, exteriorColorKey, interiorColorKey, offers, image: { width, height, alt, src }, payment, financials, exploreModelCta, pricing, specialRates, }) => {
        var _a, _b, _c, _d, _e, _f;
        const { sellingPrice } = payment || {};
        const { defaultPaymentMethod, financeDownPayment, leaseDownPayment } = financials;
        const { validPaymentTabs, fallbackPaymentFrequency, fallbackPaymentTerm } = config;
        const hasDiscount = !!((_a = pricing === null || pricing === void 0 ? void 0 : pricing.discount) === null || _a === void 0 ? void 0 : _a.priceDiscountAmount);
        const discount = (showSellingPrice ? pricing === null || pricing === void 0 ? void 0 : pricing.discount.sellingPriceWithDiscount : pricing === null || pricing === void 0 ? void 0 : pricing.discount.msrpWithDiscount) || 0;
        const paymentTabsRecord = Object.fromEntries(validPaymentTabs.map(tab => [
            tab,
            buildPaymentTab({
                type: tab,
                offers,
                payment,
                financials,
                fallbackPaymentTerm,
                fallbackPaymentFrequency,
                specialRates,
                hasLoyaltyOffer,
            }),
        ]));
        const paymentTabs = validPaymentTabs.map(tabType => paymentTabsRecord[tabType]).filter(tab => !!tab);
        const ctaTemplateDictionary = {
            modelKey,
            trimKey,
            transmissionKey,
            modelYear,
            exteriorColorKey,
            interiorColorKey,
            loyalty: String(hasLoyaltyOffer),
        };
        const cta1 = primaryCta && parseTemplateCtaLink(primaryCta, ctaTemplateDictionary);
        const cta2 = secondaryCta && parseTemplateCtaLink(secondaryCta, ctaTemplateDictionary);
        const fallBackPaymentTab = getFallbackPaymentTab(offers, validPaymentTabs);
        return {
            modelInformation: {
                modelName,
                modelYear,
                trimName,
                modelLogo,
                modelKey,
                trimKey,
                transmissionId,
                transmissionKey,
                exteriorColorKey,
                interiorColorKey,
            },
            sellingPrice: {
                sellingPrice: (sellingPrice === null || sellingPrice === void 0 ? void 0 : sellingPrice.value) || 0,
                discount: hasDiscount ? discount : 0,
            },
            disclaimerData: {
                feesAmount: (_b = payment === null || payment === void 0 ? void 0 : payment.leviesAndFeesTotal) !== null && _b !== void 0 ? _b : 0,
                dealerFee: (_e = (_d = (_c = payment === null || payment === void 0 ? void 0 : payment.levies) === null || _c === void 0 ? void 0 : _c.find(item => { var _a; return ((_a = item.key) === null || _a === void 0 ? void 0 : _a.toString().toLocaleLowerCase()) == 'dealer_fees'; })) === null || _d === void 0 ? void 0 : _d.price) !== null && _e !== void 0 ? _e : 0,
                freightAmount: (_f = payment === null || payment === void 0 ? void 0 : payment.freightAndPdi) !== null && _f !== void 0 ? _f : 0,
            },
            ctas: { ...(cta1 && { inventory: cta1 }), ...(cta2 && { buildAndPrice: cta2 }), exploreCTA: exploreModelCta },
            modelImage: {
                height,
                width,
                alt,
                src,
            },
            downPayment: {
                financeDownPayment,
                leaseDownPayment,
            },
            paymentTabs,
            defaultPaymentTab: !defaultPaymentMethod
                ? fallBackPaymentTab
                : paymentMethodTabTypeRecord[defaultPaymentMethod],
            hasLoyaltyOffer,
            onPaymentMethodChange,
            payment,
        };
    });
    return cards;
}
export default convertTrimsDataToCardProps;
